import { render } from "./icons-arrow-down.svg?vue&type=template&id=30e97194?inline"
const script = {}
script.render = render

export default script